/**
 * Shortening for the commands this portal generates.
 *
 * Every generated command carries an opaque payload — a bundle run token, a base64
 * `-DeploymentConfig` sidecar — that runs to hundreds of characters, is read by nobody, and pushes
 * the half of the command that identifies it off the screen. Only the payload is elided, so the
 * command still reads as itself: the executable, its verb and its flags all survive.
 */

/** Flags whose value is a blob, not something to read. */
const PAYLOAD_FLAGS = ['--token', '-DeploymentConfig']

/** Below this a value costs less to show whole than the ellipsis costs to read. */
const ELIDE_OVER = 24
const HEAD = 8
const TAIL = 4

const escapeRe = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

/** `--token eyJhbGciOi…nEHY` — enough of the value to tell two of them apart, no more. */
export function elidePayloads(command: string): string {
  return PAYLOAD_FLAGS.reduce((out, flag) => {
    // A PowerShell one-liner chains with `;`, so the value ends at a semicolon as readily as at a
    // space — without that the elision would swallow the statements that follow.
    const re = new RegExp(`(${escapeRe(flag)}[ \\t]+)(["']?)([^\\s"';]+)`, 'g')
    return out.replace(re, (whole, lead, quote, value: string) =>
      value.length > ELIDE_OVER
        ? `${lead}${quote}${value.slice(0, HEAD)}…${value.slice(-TAIL)}`
        : whole,
    )
  }, command)
}
